module.exports = __webpack_public_path__ + "static/media/LazyAz_web5.1145c01f.jpg";